export const generateTableHeaders = (classname, isGrowthEnabled, isMidTestEnabled) => {
  return (
    <>
      <th rowSpan={2} className={`${classname} border rounded-0`}>Pre-Test</th>
      <th rowSpan={2} className={`${classname} border`}>Completion</th>
      {isMidTestEnabled &&
        <>
          <th rowSpan={2} className={`${classname} border`}>Mid-Test</th>
          <th rowSpan={2} className={`${classname} border`}>Completion</th>
        </>
      }
      {isGrowthEnabled && isMidTestEnabled &&
        <th rowSpan={2} className={`${classname} border`}>Pre-Mid<br />Growth</th>
      }
      <th rowSpan={2} className={`${classname} border`}>Post-Test</th>
      <th rowSpan={2} className={`${classname} border`}>Completion</th>
      {isGrowthEnabled && isMidTestEnabled &&
        <th rowSpan={2} className={`${classname} border`}>Mid-Post<br />Growth</th>
      }
      {isGrowthEnabled &&
        <th rowSpan={2} className={`${classname} border`}>Pre-Post<br />Growth</th>
      }
    </>
  );
};